import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { environment } from 'src/environments/environment';

export interface taskManagementInterface {
	analyst?: number;
	analysts?: any[];
	category?: string;
	categoryName?: string;
	confirmDelete?: boolean;
	description?: string;
	enduserApproval?: 0 | 1;
	enduserSupervisor?: 0 | 1;
	expanded?: boolean;
	group?: number;
	groupName?: string;
	id?: number | string;
	predecessor?: string;
	request?: string;
	required?: 0 | 1;
	scope?: string;
	scopeName?: string;
	severity?: string;
	serviceType?: string;
	serviceTypeId?: string;
	sla?: number;
	slaId?: number;
	slavip?: number;
	solutionArea?: string;
	solutionAreaId?: string;
	solutionAreaMock?: string;
	taskId?: number;
	task?: string;
	template?: number | string;
	topic?: string;
	topicName?: string;
	type?: string;
	uploadRequired?: 0 | 1;
	urgentChange?: 0 | 1;
	waitingFinish?: 0 | 1;
}

@Injectable({
	providedIn: 'root',
})
export class TaskManagementService {
	private getGroupTasksUrl = environment.baseApiUrl + 'register/task';
	private getAnalystsByCustomerUrl = environment.baseApiUrl + 'register/task/analystsByCustomer';
	private getSolutionAreaByCustomerUrl = environment.baseApiUrl + 'register/task/solutionAreaByCustomer';
	private getSolutionAreaByServiceTypeUrl = environment.baseApiUrl + 'register/task/solutionAreaByServiceType';

	private getScopesByServiceTypeUrl = environment.baseApiUrl + 'register/task/scopesByServiceType';
	private getCategoryByScopeUrl = environment.baseApiUrl + 'register/task/categoryByScope';
	private getTopicByCategoryUrl = environment.baseApiUrl + 'register/task/topicByCategory';

	private getSeveritiesUrl = environment.baseApiUrl + 'register/task/severities';
	private getTasksTemplatesUrl = environment.baseApiUrl + 'register/task/tasksTemplates';
	private postTasksUrl = environment.baseApiUrl + 'register/task';
	private putTasksUrl = environment.baseApiUrl + 'register/task/{id}';
	private deleteTasksUrl = environment.baseApiUrl + 'register/task/{id}';

	constructor(
		private http: HttpClient,
		private AuthLoginService: AuthLoginService
	) {}

	getGroupTasks(filters: any): Observable<taskManagementInterface[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		let parameters = new HttpParams();

		for (const key of Object.keys(filters)) {
			if (filters[key]) {
				parameters = parameters.append(key, filters[key]);
			}
		}

		return this.http.get<taskManagementInterface[]>(this.getGroupTasksUrl, { headers: headers, params: parameters });
	}

	getAnalystsByCustomer(filters: any): Observable<any[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		let parameters = new HttpParams();

		for (const key of Object.keys(filters)) {
			if (filters[key]) {
				parameters = parameters.append(key, filters[key]);
			}
		}

		return this.http.get<any[]>(this.getAnalystsByCustomerUrl, { headers: headers, params: parameters });
	}

	getSolutionAreaByServiceType(filters: any): Observable<any[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		let parameters = new HttpParams();

		for (const key of Object.keys(filters)) {
			if (filters[key]) {
				parameters = parameters.append(key, filters[key]);
			}
		}

		return this.http.get<any[]>(this.getSolutionAreaByServiceTypeUrl, { headers: headers, params: parameters });
	}

	getScopesByServiceType(filters: any): Observable<any[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		let parameters = new HttpParams();

		for (const key of Object.keys(filters)) {
			if (filters[key]) {
				parameters = parameters.append(key, filters[key]);
			}
		}

		return this.http.get<any[]>(this.getScopesByServiceTypeUrl, { headers: headers, params: parameters });
	}

	getCategoryByScope(filters: any): Observable<any[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		let parameters = new HttpParams();

		for (const key of Object.keys(filters)) {
			if (filters[key]) {
				parameters = parameters.append(key, filters[key]);
			}
		}

		return this.http.get<any[]>(this.getCategoryByScopeUrl, { headers: headers, params: parameters });
	}

	getTopicByCategory(filters: any): Observable<any[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		let parameters = new HttpParams();

		for (const key of Object.keys(filters)) {
			if (filters[key]) {
				parameters = parameters.append(key, filters[key]);
			}
		}

		return this.http.get<any[]>(this.getTopicByCategoryUrl, { headers: headers, params: parameters });
	}

	getSolutionAreaByCustomer(filters?: any): Observable<any[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		let parameters = new HttpParams();

		for (const key of Object.keys(filters)) {
			if (filters[key]) {
				parameters = parameters.append(key, filters[key]);
			}
		}

		return this.http.get<any[]>(this.getSolutionAreaByCustomerUrl, { headers: headers, params: parameters });
	}

	getSeverities(): Observable<any[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});

		return this.http.get<any[]>(this.getSeveritiesUrl, { headers: headers });
	}

	getTasksTemplates(filters: any): Observable<any[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		let parameters = new HttpParams();

		for (const key of Object.keys(filters)) {
			if (filters[key]) {
				parameters = parameters.append(key, filters[key]);
			}
		}

		return this.http.get<any[]>(this.getTasksTemplatesUrl, { headers: headers, params: parameters });
	}

	postTask(task: any): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});

		return this.http.post<any>(this.postTasksUrl, task, { headers: headers });
	}

	updateTask(task: any): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const putTasksUrl = this.putTasksUrl.replace('{id}', task.id);

		return this.http.put<any>(putTasksUrl, task, { headers: headers });
	}

	deleteTask(filters: any): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		let parameters = new HttpParams();
		const deleteTasksUrl = this.deleteTasksUrl.replace('{id}', filters.id);

		for (const key of Object.keys(filters)) {
			if (filters[key]) {
				parameters = parameters.append(key, filters[key]);
			}
		}

		return this.http.delete<any>(deleteTasksUrl, { headers: headers, params: parameters });
	}
}
